import { createContext } from 'react';

type RouteContextType = {
  dispatch: (action: any) => void;
  getState: () => any;
};
const RouteContext = createContext<RouteContextType>({
  dispatch: () => {},
  getState: () => ({}),
});

export default RouteContext;
